import React from "react";

const formatNumber = (value, digits = 2) =>
  Number.isFinite(value) ? value.toFixed(digits) : "-";

const formatCorners = (corners = []) =>
  corners.length === 4
    ? corners
        .map(
          (corner, index) =>
            `${["TL", "TR", "BR", "BL"][index]} ${formatNumber(
              corner.x,
              3,
            )},${formatNumber(corner.y, 3)}`,
        )
        .join(" | ")
    : "-";

const formatBoolean = (value) => (value ? "true" : "false");

export const isDocumentDetectionDebugEnabled = () => {
  if (typeof globalThis.location === "undefined") return false;
  return (
    new URLSearchParams(globalThis.location.search).get("kycDebug") === "1"
  );
};

// 仅在 URL 带 ?kycDebug=1 时显示，用来现场核对四角、容错条件和稳定帧。
export function DocumentDetectionDebug({ detection }) {
  if (!isDocumentDetectionDebugEnabled()) return null;

  const angleValid = detection?.angleValid && detection?.perspectiveValid;
  const rows = [
    ["detected", formatBoolean(detection?.detected)],
    ["confidence", formatNumber(detection?.confidence, 3)],
    ["corners", formatCorners(detection?.corners)],
    ["widthRatio", formatNumber(detection?.widthRatio, 3)],
    ["heightRatio", formatNumber(detection?.heightRatio, 3)],
    ["angle", `${formatNumber(detection?.angle, 2)}°`],
    ["positionValid", formatBoolean(detection?.positionValid)],
    ["nearPosition", formatBoolean(detection?.nearPositionValid)],
    ["sizeValid", formatBoolean(detection?.sizeValid)],
    ["nearSize", formatBoolean(detection?.nearSizeValid)],
    ["angleValid", formatBoolean(angleValid)],
    ["nearAngle", formatBoolean(detection?.nearAngleValid)],
    ["nearPerspective", formatBoolean(detection?.nearPerspectiveValid)],
    ["complete", formatBoolean(detection?.complete)],
    ["recordingReady", formatBoolean(detection?.recordingReady)],
    ["stableFrames", detection?.stableFrames ?? 0],
    ["detectorFPS", formatNumber(detection?.detectorFps, 1)],
  ];

  return (
    <aside
      className="document-detection-debug pointer-events-none absolute left-2 top-11 z-30 max-w-[calc(100%-1rem)] rounded-lg border border-white/20 bg-slate-950/85 p-2 font-mono text-[9px] leading-4 text-white shadow-lg backdrop-blur"
      aria-label="Document detection debug metrics"
    >
      {rows.map(([label, value]) => (
        <div
          key={label}
          className={
            label === "corners" ? "max-w-full break-all" : "flex gap-2"
          }
        >
          <span className="text-teal-300">{label}</span>
          <span>{value}</span>
        </div>
      ))}
    </aside>
  );
}
